<script setup lang="ts">
import { useTheme } from '@/composables/useTheme'
import ToolsPage from './views/ToolsPage.vue'

// 复用主应用主题逻辑，导航页面自动响应系统明暗主题
useTheme()
</script>

<template>
  <ToolsPage />
</template>
